import { useSelector } from 'react-redux';
import { AppState } from 'modules/redux-store';

export const useFaqData = () => {
  const data = useSelector((state: AppState) => state.faq);
  return { data };
};
